import { render } from "./detailsOrganization.vue?vue&type=template&id=40650103&scoped=true"
import script from "./detailsOrganization.vue?vue&type=script&lang=js"
export * from "./detailsOrganization.vue?vue&type=script&lang=js"

import "vue-multiselect/dist/vue-multiselect.css?vue&type=style&index=0&lang=css&external"
import "./detailsOrganization.vue?vue&type=style&index=1&id=40650103&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40650103"]])

export default __exports__